"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  customFooter: _propTypes["default"].node,
  href: _propTypes["default"].string,
  hrefText: _propTypes["default"].string,
  primaryAction: _propTypes["default"].func,
  primaryButtonText: _propTypes["default"].string,
  secondaryAction: _propTypes["default"].func,
  secondaryButtonText: _propTypes["default"].string
};

var CardFooter = function CardFooter(_ref) {
  var customFooter = _ref.customFooter,
      href = _ref.href,
      hrefText = _ref.hrefText,
      primaryAction = _ref.primaryAction,
      primaryButtonText = _ref.primaryButtonText,
      secondaryAction = _ref.secondaryAction,
      secondaryButtonText = _ref.secondaryButtonText;

  if (customFooter || primaryAction || secondaryAction || href) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "grv-card__footer grv-card__section--anchor"
    }, function () {
      if (customFooter) {
        return customFooter;
      }

      if (primaryAction) {
        var primaryButton = /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          compact: true,
          onClick: primaryAction,
          type: "progressive"
        }, primaryButtonText);

        if (!secondaryAction) {
          return /*#__PURE__*/_react["default"].cloneElement(primaryButton, {
            className: 'grv-float--right'
          });
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "grv-float--right"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          compact: true,
          onClick: secondaryAction,
          type: "text"
        }, secondaryButtonText), primaryButton);
      }

      if (href) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          className: "grv-button--text-directional-right grv-card__link--expand",
          href: href
        }, hrefText);
      }

      return null;
    }());
  }

  return null;
};

CardFooter.propTypes = propTypes;
var _default = CardFooter;
exports["default"] = _default;